import OtpInput from 'react-otp-input';
import { Alert, KeenIcon } from '@/components';
import { Skeleton } from '@/components/ui/skeleton'
import { FormattedMessage } from 'react-intl';

const OTPModal = ({
  open,
  onClose,
  onSubmit,
  otp,
  setOtp,
  isLoading,
  title,
  description,
  qrCode,
  qrCodeError,
  secret,
  disable2FA
}) => {
  if (!open) return null;

  return (
    <div className="modal-wrapper modal-animate-fade">
      <form
        onSubmit={(e) => {
          e.preventDefault();
          onSubmit();
        }}
        className="modal-body modal-animate-scale w-4/5 max-w-md"
      >
        <button
          type="button"
          onClick={onClose}
          className="modal-close-btn"
        >
          <KeenIcon icon="cross" />
        </button>

        <h2 className="text-lg font-medium text-gray-900 mb-5">{title}</h2>
        {description && (
          <div className="mt-1 mb-5 text-sm text-gray-800">
            {description}
          </div>
        )}
        {!disable2FA && (
          <div className="mb-5 text-center">
            {qrCode ? (
              <img src={qrCode} alt="QR Code" className="mx-auto" />
            ) : qrCodeError ? (
              <p className="text-center text-red-500 text-sm py-6">
                {qrCodeError === 'Too Many Attempts.' ? (
                  <>
                    <FormattedMessage id="account_security.verification_unavailable" /> <br /> <FormattedMessage id="account_security.please_wait_and_try_again" />
                  </>
                ) : (
                  qrCodeError
                )}
              </p>
            ) : (
              <Skeleton className="size-[200px] mx-auto" />
              // <p className="text-center py-6 text-sm">Loading QR Code...</p>
            )}

            {secret && (
              <Alert variant="warning" className="mt-5 text-start">
                <FormattedMessage id="user_reset_password.trouble_using_qr" /> <br />
                <span className="text-xs font-bold text-gray-800 tracking-wider">{secret}</span>
              </Alert>
            )}
          </div>
        )}

        <div className="my-4">
          <label className="form-label text-gray-900 mb-1 w-fit mx-auto"><FormattedMessage id="user_reset_password.enter_otp" /></label>
          <div className="flex justify-center gap-2.5">
            <OtpInput
              value={otp}
              onChange={setOtp}
              numInputs={6}
              isInputNum
              shouldAutoFocus
              containerStyle="flex gap-2"
              renderInput={(props) => (
                <input
                  {...props}
                  className="input focus:border-primary-clarity focus:ring focus:ring-primary-clarity !size-10 shrink-0 px-0 text-center"
                />
              )}
            />
          </div>
        </div>

        <button
          type="submit"
          disabled={isLoading || !otp}
          className="w-full btn btn-primary flex justify-center"
        >
          {isLoading ? <FormattedMessage id="USER.MENU.PLEASE_WAIT" /> : <FormattedMessage id="user_reset_password.submit_otp" />}
        </button>
      </form>
    </div>
  );
};

export { OTPModal }